import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PageContainer from '../../components/Layout/PageContainer';
import PageHeader from '../../components/Layout/PageHeader';
import { MainApi } from '../../utils/MainApi';
import Switcher from '../../components/Switcher/Switcher';
import './Menu.css';

const TYPE_OPTIONS = [
  { value: 'eat', label: 'Еда' },
  { value: 'drink', label: 'Напитки' },
];

const MenuForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);

  const [formData, setFormData] = useState({
    title: '',
    description: '',
    category: 'eat',
    weight: '',
    price: '',
    active: true,
  });

  const [loading, setLoading] = useState(isEdit);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isEdit) {
      const fetchMenuItem = async () => {
        try {
          const data = await MainApi.getOneMenuItem(id);
          setFormData({
            title: data.title || '',
            description: data.description || '',
            category: data.category || 'eat',
            weight: data.weight !== null ? data.weight.toString() : '',
            price: data.price !== null ? data.price.toString() : '',
            active: data.active,
          });
        } catch (err) {
          console.error(err);
          setError('Не удалось загрузить данные позиции');
        } finally {
          setLoading(false);
        }
      };
      fetchMenuItem();
    }
  }, [id, isEdit]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.title.trim()) {
      setError('Поле "Название" обязательно для заполнения');
      return;
    }

    setSaving(true);
    setError(null);
    try {
      const payload = {
        title: formData.title.trim(),
        description: formData.description.trim() || null,
        category: formData.category || null,
        weight: formData.weight ? parseInt(formData.weight, 10) : null,
        price: formData.price ? parseInt(formData.price, 10) : null,
        active: formData.active,
      };

      if (isEdit) {
        await MainApi.updateMenuItem(id, payload);
      } else {
        await MainApi.createMenuItem(payload);
      }
      navigate('/menu');
    } catch (err) {
      console.error(err);
      setError(isEdit ? 'Ошибка при обновлении позиции' : 'Ошибка при создании позиции');
      setSaving(false);
    }
  };

  return (
    <PageContainer maxWidth="800px">
      <PageHeader
        title={isEdit ? 'Редактирование позиции' : 'Новая позиция меню'}
        subtitle="Заполните информацию о позиции"
        onBack={() => navigate('/menu')}
      />

      {error && (
        <div style={{ color: 'red', marginBottom: '16px', padding: '12px', background: '#fee', borderRadius: '4px' }}>
          {error}
        </div>
      )}

      {loading ? (
        <p>Загрузка данных...</p>
      ) : (
        <form className="menu-form" onSubmit={handleSubmit}>
          <div className="menu-form__row">
            <label className="menu-form__label">Название *</label>
            <input
              className="menu-form__input"
              value={formData.title}
              onChange={(e) => handleChange('title', e.target.value)}
              placeholder="Например: Сет бургеров"
            />
          </div>

          <div className="menu-form__row">
            <label className="menu-form__label">Описание / Состав</label>
            <textarea
              className="menu-form__input"
              value={formData.description}
              onChange={(e) => handleChange('description', e.target.value)}
              rows={3}
              placeholder="Описание блюда или состав..."
            />
          </div>

          <div className="menu-form__row">
            <label className="menu-form__label">Категория</label>
            <Switcher
              options={TYPE_OPTIONS}
              value={formData.category}
              onChange={(val) => handleChange('category', val)}
            />
          </div>

          <div className="menu-form__row menu-form__grid">
            <div>
              <label className="menu-form__label">Цена (₽)</label>
              <input
                className="menu-form__input"
                type="number"
                value={formData.price}
                onChange={(e) => handleChange('price', e.target.value)}
                placeholder="0"
              />
            </div>
            <div>
              <label className="menu-form__label">Выход (вес/объем)</label>
              <div className="menu-form__input-wrapper">
                <input
                  className="menu-form__input"
                  type="number"
                  value={formData.weight}
                  onChange={(e) => handleChange('weight', e.target.value)}
                  placeholder="Укажите число"
                  style={{ paddingRight: '32px' }}
                />
                {(formData.category === 'eat' || formData.category === 'drink') && (
                  <span className="menu-form__input-suffix">
                    {formData.category === 'eat' ? 'г' : 'мл'}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div style={{ height: '80px' }} />

          <div className="proto-sticky-bar">
            <div className="proto-sticky-content">
              <button
                type="submit"
                className="proto-btn proto-btn-primary"
                disabled={saving}
              >
                {saving ? 'Сохранение...' : (isEdit ? 'Сохранить изменения' : 'Создать позицию')}
              </button>
            </div>
          </div>
        </form>
      )}
    </PageContainer>
  );
};

export default MenuForm;
